import { compressToEncodedURIComponent } from 'lz-string';

export default function encodeQueryData(input) {
  return compressToEncodedURIComponent(JSON.stringify(input));
}
